import React from 'react';
import SEO from '../components/SEO';
import './VenueDetail.css';

function FamilyRoom() {
  return (
    <div className="venue-detail-page">
      <SEO
        title="패밀리 라운지 | Family Lounge"
        description="양가 부모님을 위한 프라이빗 패밀리 라운지. 편안한 대기와 환담을 위한 별도 공간."
        path="/venue/family-lounge"
      />
      {/* Hero */}
      <section className="detail-hero">
        <div className="hero-image">
          <img src="/images/family-room/family-hero.jpg" alt="Family Lounge" />
          <div className="hero-overlay">
            <div className="container">
              <div className="hero-content fade-in">
                <h1>Family Lounge</h1>
                <p className="capacity-tag">Private Space for Parents</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="detail-description">
        <div className="container">
          <div className="space-notice fade-in">
            <span className="notice-tag">📷 Season Preview</span>
          </div>
          <div className="description-content fade-in">
            <h2>A Quiet Retreat for Family</h2>
            <p>
              A comfortable, private space where parents and immediate family
              can relax before and during the celebration.
            </p>
            <p>
              Away from the bustle, yet close to everything—
              the perfect balance of privacy and accessibility.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="detail-gallery">
        <div className="container-wide">
          <div className="gallery-grid fade-in">
            {[1, 2, 3, 4].map((num) => (
              <div key={num} className="gallery-item">
                <img 
                  src={`/images/family-room/family-${num}.jpg`}
                  alt={`Family Lounge ${num}`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.classList.add('placeholder');
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="detail-features">
        <div className="container">
          <div className="features-content fade-in">
            <h2>Amenities</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Comfortable Seating</h3>
                <p>Plush sofas and chairs</p>
              </div>
              <div className="feature-item">
                <h3>Quiet Atmosphere</h3>
                <p>Soundproofed for privacy</p>
              </div>
              <div className="feature-item">
                <h3>Refreshments</h3>
                <p>Tea, coffee, and light snacks</p>
              </div>
              <div className="feature-item">
                <h3>Easy Access</h3>
                <p>Close to main ceremony area</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FamilyRoom;
